import getItem from 'mini-localstorage/lib/utils/getItem';
import { getSidePaneNewItemList } from './getSidePaneNewItemList';
import { SIDE_PANE_NEW_ITEMS_KEY } from './constants';

export const shouldHighlightSidePane = async () => {
    const itemsInLocalStorage = getItem(SIDE_PANE_NEW_ITEMS_KEY);
    const sidePaneNewItemList = await getSidePaneNewItemList();

    return !sidePaneNewItemList.every(item => itemsInLocalStorage?.includes(item));
};
